async function getFlattenedProducts ($http, sortBy) {
  const products = []
  await $http.product
    .include(['children'])
    .orderBy(sortBy)
    .fetch((items) => {
      items.map((product) => {
        if (product.children.length) {
          product.children.map((children) => {
            products.push(children)
          })
        }
        delete product['children']
        products.push(product)
      })
    })

  return products
}

async function productsSKU ($http) {
  const products = await getFlattenedProducts($http, 'sku')
  return products && products.length ? products.map((item) => item.sku) : []
}

async function productsName ($http) {
  const products = await getFlattenedProducts($http, 'name')
  return products && products.length ? products.map((item) => item.name) : []
}

const textOperators = [
  { text: 'equals', value: 'equals' },
  { text: 'does not equals', value: 'does not equals' },
  { text: 'contains', value: 'contains' },
  { text: 'does not contain', value: 'does not contain' },
  { text: 'is empty', value: 'is empty' },
  { text: 'begins with', value: 'begins with' },
  { text: 'ends with', value: 'ends with' }
]

export default {
  operators: [
    { text: 'is', value: 'equals' },
    { text: 'is', value: '=' },
    { text: 'not', value: 'does not equals' },
    { text: 'not', value: '<>' },
    { text: '>', value: '>' },
    { text: '<', value: '<' },
    { text: '>=', value: '>=' },
    { text: '<=', value: '<=' }
  ],
  types: {
    numeric: [
      '>',
      '<',
      '=',
      '<>',
      '<=',
      '>='
    ],
    text: [
      'equals',
      'does not equals',
      'contains',
      'does not contain',
      'is empty',
      'is not empty',
      'begins with',
      'ends with'
    ],
    select: [
      '=',
      '<>'
    ],
    multi: [
      '>',
      '<',
      '=',
      '<>',
      '<=',
      '>='
    ],
    radio: [
      '='
    ],
    checkbox: [
      '>',
      '<',
      '=',
      '<>',
      '<=',
      '>='
    ],
    sum: [
      '>',
      '<',
      '=',
      '<>',
      '<=',
      '>='
    ]
  },

  operands: [
    {
      text: 'Total items amount',
      value: 'summary.total_items_amount.amount',
      type: 'numeric',
      subtype: 'money',
      operators: [
        '>',
        '<',
        '=',
        '<>',
        '<=',
        '>='
      ],
      usage: 'rule'
    },
    {
      text: 'Total items count',
      value: 'summary.total_items_count',
      type: 'numeric',
      operators: [
        '>',
        '<',
        '=',
        '<>',
        '<=',
        '>='
      ],
      usage: 'rule'
    },
    {
      text: 'Item SKU',
      value: 'items.*.sku',
      type: 'text',
      usage: 'rule',
      options: productsSKU,
      operators: textOperators,
      subsets: ['items']
    },
    {
      text: 'Item name',
      value: 'items.*.name',
      type: 'text',
      usage: 'rule',
      operators: textOperators,
      subsets: ['items']
    },
    {
      text: 'Item brand',
      value: 'items.*.brand',
      type: 'text',
      usage: 'rule',
      operators: textOperators,
      subsets: ['items']
    },
    {
      text: 'Items type',
      value: 'items.*.type',
      type: 'select',
      operators: [
        { text: 'is', value: '=' }
      ],
      options: [
        { text: 'Digital', value: 'digital' },
        { text: 'Physical', value: 'physical' },
        { text: 'Service', value: 'service' }
      ],
      usage: 'rule',
      subsets: ['items']
    },
    {
      text: 'Shipping region',
      value: 'shipping_address.administrative_area',
      type: 'text',
      operators: [
        { text: 'equals', value: 'equals' }
      ],
      usage: 'rule'
    },
    {
      text: 'Items quantity',
      value: 'items.*.quantity',
      type: 'sum',
      operators: [
        '>',
        '<',
        '=',
        '<>',
        '<=',
        '>='
      ],
      usage: 'rule',
      subsets: ['items']
    },
    {
      subset: 'items',
      text: 'Item type',
      value: 'type',
      type: 'select',
      operators: [
        { text: 'is', value: '=' }
      ],
      options: [
        { text: 'Digital', value: 'digital' },
        { text: 'Physical', value: 'physical' },
        { text: 'Service', value: 'service' }
      ],
      usage: 'subset'
    },
    {
      text: 'Item Name',
      subset: 'items',
      value: 'name',
      type: 'checkbox',
      operators: [{ text: 'in', value: '=' }],
      options: productsName,
      usage: 'subset'
    },
    {
      text: 'Item SKU',
      subset: 'items',
      value: 'sku',
      type: 'checkbox',
      operators: [
        { text: 'in', value: '=' }
      ],
      options: productsSKU,
      usage: 'subset'
    },
    {
      text: 'Taxonomy',
      value: 'taxonomy',
      type: 'select',
      operators: [
        { text: 'is', value: '=' }
      ],
      subset: 'items',
      options: async ($http) => {
        let result = await $http.make('taxonomy').get()
        result = result && result.length ? result.map(item => {
          return {
            text: item.name,
            value: item.code
          }
        }) : []

        return result
      },
      usage: 'subset'
    }
  ]
}
